import { DBCollection } from '@/lib/utils/constants-shared';
import type { Firestore } from 'firebase/firestore';
import { collection, getDocs } from 'firebase/firestore';

import { fetchCollectionFromStorage } from '@/lib/utils/storage-bulk-data';
import type { FirebaseStorage } from 'firebase/storage';

/**
 * Fetch culture by passage from DB (Storage first, then Firestore)
 */
export async function fetchCultureByPassageFromDB(
  auth: any,
  db: Firestore,
  storage?: FirebaseStorage
): Promise<CultureByPassage[]> {
  const fallback = async () => {
    const cultureByPassageRef = collection(db, DBCollection.cultureByPassage);
    const snapshot = await getDocs(cultureByPassageRef);

    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      dateCreated: doc.data().dateCreated?.toDate(),
      dateUpdated: doc.data().dateUpdated?.toDate()
    })) as CultureByPassage[];
  };

  if (storage) {
    return await fetchCollectionFromStorage<CultureByPassage>(
      storage,
      `bulk-data/${DBCollection.cultureByPassage}.json`,
      fallback
    );
  }

  return await fallback();
}


